module.exports = __webpack_public_path__ + "img/licota.3de2290a.png";